'use strict';

var React = require('react');

var SvgEnterMajor = function SvgEnterMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.44 17.56a1.5 1.5 0 0 1-.44-1.06v-1.5a1 1 0 1 1 2 0v1h12v-12h-12v1a1 1 0 0 1-2 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.06-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.707 9.292-3-3a1 1 0 1 0-1.414 1.414l1.293 1.293h-7.586a1 1 0 0 0 0 2h7.586l-1.293 1.293a.992.992 0 0 0-.293.707 1 1 0 0 0 1.707.707l3-3a.997.997 0 0 0 0-1.414z"
  }));
};

exports.SvgEnterMajor = SvgEnterMajor;
